"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUserGroupsFromIdp = exports.formatProviderNameAsOrganizationId = exports.isOrganizationSamlProvider = exports.isWorkspaceSamlProvider = void 0;
const isWorkspaceSamlProvider = (providerName) => {
    const LAST_UUID_REGEX = /^[0-9a-f]{12}$/i;
    return typeof providerName === 'string' && LAST_UUID_REGEX.test(providerName);
};
exports.isWorkspaceSamlProvider = isWorkspaceSamlProvider;
const isOrganizationSamlProvider = (providerName) => {
    const UUID_REGEX = /^[0-9a-f]{32}$/i;
    return typeof providerName === 'string' && UUID_REGEX.test(providerName);
};
exports.isOrganizationSamlProvider = isOrganizationSamlProvider;
const formatProviderNameAsOrganizationId = (providerName) => providerName.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');
exports.formatProviderNameAsOrganizationId = formatProviderNameAsOrganizationId;
const parseUserGroupsFromIdp = (userGroups) => {
    if (!userGroups)
        return [];
    userGroups = userGroups.trim();
    let parsedGroups = [];
    if (userGroups.startsWith('[') && userGroups.endsWith(']')) {
        try {
            parsedGroups = JSON.parse(userGroups);
        }
        catch (e) {
            console.warn(`Error parsing userGroups "${userGroups}". Not a valid JSON string. Falling back to comma separated list.`);
            parsedGroups = userGroups
                .substring(1, userGroups.length - 1)
                .split(',')
                .map((group) => group.trim());
        }
    }
    else {
        parsedGroups = userGroups.split(',').map((group) => group.trim());
    }
    console.log('Parsed groups:', parsedGroups);
    return parsedGroups.filter(Boolean);
};
exports.parseUserGroupsFromIdp = parseUserGroupsFromIdp;
//# sourceMappingURL=cognito.js.map